import { useTranslation } from "react-i18next";
import { PropertyReport } from "../../Models/PropertyReport";
import { useEffect, useState } from "react";


const SectionPhotos: React.FunctionComponent<{ reportValue: PropertyReport ,OnChangeProperty: (value: any) => void }> = (props) => {

    const [isShow, setIsShow] = useState(true);

    useEffect(() => {
        if (props.reportValue.listImages && props.reportValue.listImages.length === 0) {
            setIsShow(false);
        } else {
            setIsShow(true);
        }
    }, [props.reportValue.listImages]);
    
    const DeleteSectionPhotos = () => {
        setIsShow(false);
        props.OnChangeProperty([]);
    }

    return (<>
        {
            isShow && props.reportValue.listImages && props.reportValue.listImages.length > 0 && (
                <div className="card border-16 mb-3 mt-4 ">
                    <button className="b-close" onClick={DeleteSectionPhotos}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.29537 23.9961C1.70174 24.0308 1.1179 23.8325 0.666962 23.4429C-0.222321 22.5438 -0.222321 21.0917 0.666962 20.1926L20.1393 0.62202C21.0643 -0.247834 22.5156 -0.199479 23.3811 0.730116C24.1638 1.57074 24.2094 2.86281 23.4879 3.75703L3.90082 23.4429C3.45575 23.8268 2.88122 24.0248 2.29537 23.9961Z" fill="white" />
                            <path d="M21.541 23.9876C20.9417 23.985 20.3675 23.7455 19.942 23.3207L0.549244 3.79566C-0.27126 2.83097 -0.159708 1.37917 0.798448 0.553002C1.65363 -0.184334 2.91485 -0.184334 3.76995 0.553002L23.2769 20.0779C24.1978 20.946 24.2454 22.4014 23.3833 23.3286C23.349 23.3654 23.3135 23.4011 23.2769 23.4356C23.0406 23.6425 22.7645 23.7983 22.4659 23.8932C22.1673 23.9882 21.8525 24.0203 21.541 23.9876Z" fill="white" />
                        </svg>
                    </button>
                    <div
                        className="selected-images-grid padd-20"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '16px',
                        }}
                    >
                        {props.reportValue.listImages.map((image: any, index: number) => (
                            <div
                                key={`selected-${image.id || index}`}
                                style={{
                                    position: 'relative',
                                    aspectRatio: '1/1',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    boxShadow: 'rgba(0, 0, 0, 0.1) 8px 8px 8px',
                                }}
                            >
                                <img
                                    src={image.src}
                                    alt={`Selected ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )
        }
    </>
    )

};
export default SectionPhotos;